import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Bubbles from "./components/Bubbles";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Landing from "./pages/Landing";
import Location from "./pages/Location";
import WorkInProgress from "./pages/WorkInProgress";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App relative min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Bubbles count={24} />
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/villesse" element={<Location />} />
          <Route path="/tavagnacco" element={<Location />} />
          <Route path="/work-in-progress" element={<WorkInProgress />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
